module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-ellipse-presents-money-574e235ac5e26e0fe75a4b22153c6446.svg";